import React, { Component } from "react";
import moment from "moment";
import avatarUrl from "../../../../styles/img/user-avatar.jpg";
import LikePost from "./LikePost";
import _ from "lodash";
import ClassNames from "classnames";
import { type } from "jquery";
import Lightbox from "lightbox-react";
import "lightbox-react/style.css";
import { withTranslation } from 'react-i18next';
function jsUpperCaseFirst(string) {
  return _.isEmpty(string) ? string : string.charAt(0).toUpperCase();
}
function toUpperCaseFirst(string) {
  if (!_.isEmpty(string)) {
    string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.substring(1);
  }
}

class Post extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLikes: false,
      likes: [],
      type: "image",
      browserType: "",
      photoIndex: 0,
      isOpenCover: false,
      isOpenCoverOnePhoto: false,
      isOpenMorePhotos: false,
      isOpenVideo: false,
      coverUrl: [],
      coverUrlPhotoUrls: [],
      urlVideo: [],
      urlCoverList: [],
      photoUrlsCoverUrl: [],
      tempPhotoUrlsCoverUrl: [],
    };
    this.openLikeModal = this.openLikeModal.bind(this);
    this.onCloseLikeModal = this.onCloseLikeModal.bind(this);
    this.detectMob = this.detectMob.bind(this);
  }

  componentWillMount() {
    var listUrlPhotoCover = [];
    var urlVideo = [];
    var listUrlsPhotos = [];
    var listUrlsPhotosCover = [];

    if (this.props.post.typePoste === "PHOTOS" && this.props.post.photoUrls) {
      listUrlsPhotos.push(this.props.post.coverUrl);
      this.props.post.photoUrls.map((element) => {
        listUrlsPhotos.push(element);
      });
      this.props.post.photoUrls.map((element) => {
        listUrlsPhotosCover.push(element);
      });
      listUrlsPhotosCover.push(this.props.post.coverUrl);

      this.setState({
        coverUrlPhotoUrls: listUrlsPhotos,
        photoUrlsCoverUrl: listUrlsPhotosCover,
      });
    } else if (
      this.props.post.typePoste === "PHOTOS" &&
      this.props.post.photoUrls == undefined
    ) {
      listUrlPhotoCover.push(this.props.post.coverUrl);
      this.setState({
        coverUrl: listUrlPhotoCover,
      });
    } else {
      this.setState({
        urlVideo: [this.props.post.videoUrl],
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.post != this.props.post) {
      var listUrlPhotoCover = [];
      var urlVideo = [];
      var listUrlsPhotos = [];
      var listUrlsPhotosCover = [];
      if (this.props.post.typePoste === "PHOTOS" && this.props.post.photoUrls) {
        listUrlsPhotos.push(this.props.post.coverUrl);
        this.props.post.photoUrls.map((element) => {
          listUrlsPhotos.push(element);
        });
        this.props.post.photoUrls.map((element) => {
          listUrlsPhotosCover.push(element);
        });
        listUrlsPhotosCover.push(this.props.post.coverUrl);

        this.setState({
          coverUrlPhotoUrls: listUrlsPhotos,
          photoUrlsCoverUrl: listUrlsPhotosCover,
        });
      } else if (
        this.props.post.typePoste === "PHOTOS" &&
        this.props.post.photoUrls == undefined
      ) {
        listUrlPhotoCover.push(this.props.post.coverUrl);
        this.setState({
          coverUrl: listUrlPhotoCover,
        });
      } else {
        this.setState({
          urlVideo: [this.props.post.videoUrl],
        });
      }
    }
  }
  openLikeModal() {
    if (this.props.post.likes.length > 0) {
      this.setState({
        showLikes: true,
        likes: this.props.post.likes,
      });
    }
  }
  onCloseLikeModal() {
    this.setState({
      showLikes: false,
    });
  }

  detectMob = () => {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      this.setState({
        browserType: navigator.userAgent.match(toMatchItem),
      });
      return navigator.userAgent.match(toMatchItem);
    });
  };
  render() {
    const { t } = this.props;
    var photoIndex = this.state.photoIndex;
    return (
      <div className="card post" key={this.props.index}>
        <div className="card-body">
          {/* header post */}
          <div className="infos-post-top d-flex align-items-center justify-content-between">
            <div className="left d-flex align-items-center">
              <div className="user-avatar">
                {!_.isEmpty(this.props.post.posteur.lienPhoto) ? (
                  <img
                    src={this.props.post.posteur.lienPhoto}
                    className="img-fluid"
                    alt=""
                  />
                ) : (
                  t('communaute.no_photo')
                )}
              </div>
              <div className="name-date">
                {!_.isEmpty(this.props.post.posteur.prenom) &&
                !_.isEmpty(this.props.post.posteur.nom) ? (
                  <p className="m-0">
                    {toUpperCaseFirst(this.props.post.posteur.prenom) +
                      "" +
                      jsUpperCaseFirst(this.props.post.posteur.nom) +
                      "."}
                  </p>
                ) : (
                  <p className="m-0">{t('communaute.deleted_account')}</p>
                )}

                <p className="m-0 text-grey">
                  {t('communaute.posted_on')}{" "}
                  {moment(this.props.post.dateTime).format(" DD/MM/YYYY")} à{" "}
                  {moment(this.props.post.dateTime).format("HH[h]mm")}
                </p>
              </div>
            </div>
            <div className="right d-flex align-items-center">
              {this.props.post.privatePost === true ? (
                <a
                  href="#"
                  className="private-post"
                  data-toggle="modal"
                  data-target="#modalPostPrivate"
                ></a>
              ) : (
                " "
              )}

              {/* modal like post and number of likes */}
              <div
                className="post-like"
                data-toggle="modal"
                data-target="#modalPostLikes"
              >
                <label onClick={this.openLikeModal}>
                  {this.props.post.likes.length}
                </label>
              </div>

              {/* delete ost with delete button */}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.openModalDelete(this.props.post.id);
                }}
                className="delete-post"
              ></a>
            </div>
          </div>
          {/* body post */}
          <div className="content">
            {this.props.post.description ? (
              <p>{this.props.post.description}</p>
            ) : null}
            {this.props.post.typePoste === "PHOTOS" &&
            this.state.coverUrlPhotoUrls.length === 0 ? (
              <div className="post-medias gallery ">
                {/* cover photo */}
                <div className="media-first">
                  <a className="gallery-link" href="#">
                    <img
                      src={this.state.coverUrl}
                      name="coverUrl"
                      className="img-fluid"
                      onClick={() => {
                        this.setState({
                          isOpenCover: true,
                        });
                      }}
                    />
                  </a>
                </div>
              </div>
            ) : (
              ""
            )}
            {/* cover + 1 photo */}
            {this.props.post.typePoste === "PHOTOS" &&
            !_.isEmpty(this.state.coverUrlPhotoUrls) ? (
              <>
                <div className="post-medias gallery ">
                  <div className="media-first">
                    <a className="gallery-link" href="#">
                      <img
                        src={this.props.post.coverUrl}
                        name="coverUrl"
                        className="img-fluid"
                        onClick={() => {
                          this.setState({
                            isOpenCoverOnePhoto: true,
                            tempPhotoUrlsCoverUrl: this.state.coverUrlPhotoUrls,
                          });
                        }}
                      />
                    </a>
                  </div>
                </div>

                {this.state.coverUrlPhotoUrls.length <= 5 ? (
                  <div className="all-medias row mx-n1 align-items-center">
                    {!_.isEmpty(this.props.post.photoUrls) &&
                      this.props.post.photoUrls.map((photo, index) =>
                        index < 3 || index === 3 ? (
                          <div
                            className="media-thumb col-md-3 px-1"
                            key={index}
                          >
                            <a className="gallery-link">
                              <img
                                src={photo}
                                id={index}
                                name="photo"
                                className="img-fluid"
                                onClick={() => {
                                  this.setState({
                                    isOpenMorePhotos: true,
                                  });
                                }}
                              />
                            </a>
                          </div>
                        ) : null
                      )}
                  </div>
                ) : this.state.coverUrlPhotoUrls.length > 5 ? (
                  <>
                    <div className="all-medias row mx-n1 align-items-center">
                      {this.props.post.photoUrls
                        .slice(0, 3)
                        .map((photo, index) =>
                          index < 3 || index === 3 ? (
                            <>
                              <div
                                className="media-thumb col-md-3 px-1"
                                key={index}
                              >
                                <a className="gallery-link">
                                  <img
                                    src={photo}
                                    id={index}
                                    name="photo"
                                    className="img-fluid"
                                    onClick={() => {
                                      this.setState({
                                        isOpenMorePhotos: true,
                                      });
                                    }}
                                  />
                                </a>
                              </div>
                            </>
                          ) : (
                            ""
                          )
                        )}
                      <>
                        <div className="media-thumb col-md-3 px-1">
                          <a
                            className="gallery-link"
                            name="photo"
                            onClick={() => {
                              this.setState({
                                isOpenMorePhotos: true,
                              });
                            }}
                          >
                            <span className="more-media">
                              <span>
                                {this.props.post.photoUrls.length - 3}
                              </span>
                            </span>
                            <img
                              src={this.props.post.photoUrls[3]}
                              className="img-fluid"
                            />
                          </a>
                        </div>
                      </>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}
            {/* case : video */}
            {this.props.post.typePoste === "VIDEO" ? (
              <div className="post-medias gallery d-flex justify-content-center">
                <div className="media-first ">
                  <a
                    className="video-overlay-post "
                    className={ClassNames("gallery-link mfp-iframe", {
                      "video-overlay-ipad": this.state.browserType === "iPad",
                      "video-overlay": this.state.browserType != "iPad",
                    })}
                    href="#"
                    onClick={() => {
                      this.setState({
                        isOpenVideo: true,
                      });
                    }}
                  >
                    <video
                      id="video"
                      ref="vidRef"
                      width="80%"
                      height="100%"
                      controls={true}
                    >
                      <source src={this.state.urlVideo} type="video/mp4" />
                    </video>
                  </a>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {/* Modal like post */}
        {this.state.showLikes ? (
          <LikePost
            onCloseLikeModal={this.onCloseLikeModal}
            postId={this.props.postId}
            likes={this.state.likes}
          />
        ) : null}
        {/* Light Box for photo cover */}
        {this.state.coverUrl.length > 0 && this.state.isOpenCover == true ? (
          <Lightbox
            mainSrc={this.state.coverUrl[photoIndex]}
            nextSrc={
              this.state.coverUrl[(photoIndex + 1) % this.state.coverUrl.length]
            }
            prevSrc={
              this.state.coverUrl[
                (photoIndex + this.state.coverUrl.length - 1) %
                  this.state.coverUrl.length
              ]
            }
            onCloseRequest={() => {
              this.setState({
                isOpenCover: false,
                photoIndex: 0,
              });
            }}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + this.state.coverUrl.length - 1) %
                  this.state.coverUrl.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % this.state.coverUrl.length,
              })
            }
          />
        ) : null}
        {/* Light Box for photo cover and photo */}
        {this.state.coverUrlPhotoUrls.length !== 0 &&
        this.state.isOpenCoverOnePhoto == true ? (
          <Lightbox
            mainSrc={this.state.coverUrlPhotoUrls[photoIndex]}
            nextSrc={
              this.state.coverUrlPhotoUrls[
                (photoIndex + 1) % this.state.coverUrlPhotoUrls.length
              ]
            }
            prevSrc={
              this.state.coverUrlPhotoUrls[
                (photoIndex + this.state.coverUrlPhotoUrls.length - 1) %
                  this.state.coverUrlPhotoUrls.length
              ]
            }
            onCloseRequest={() => {
              this.setState({
                isOpenCoverOnePhoto: false,
                photoIndex: 0,
              });
            }}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + this.state.coverUrlPhotoUrls.length - 1) %
                  this.state.coverUrlPhotoUrls.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + 1) % this.state.coverUrlPhotoUrls.length,
              })
            }
          />
        ) : null}
        {/* Light Box for photo and cover photo */}
        {this.state.photoUrlsCoverUrl.length !== 0 &&
        this.state.isOpenMorePhotos == true ? (
          <Lightbox
            mainSrc={this.state.photoUrlsCoverUrl[photoIndex]}
            nextSrc={
              this.state.photoUrlsCoverUrl[
                (photoIndex + 1) % this.state.photoUrlsCoverUrl.length
              ]
            }
            prevSrc={
              this.state.photoUrlsCoverUrl[
                (photoIndex + this.state.photoUrlsCoverUrl.length - 1) %
                  this.state.photoUrlsCoverUrl.length
              ]
            }
            onCloseRequest={() => {
              this.setState({
                isOpenCover: false,
                isOpenMorePhotos: false,
                photoIndex: 0,
              });
            }}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + this.state.photoUrlsCoverUrl.length - 1) %
                  this.state.photoUrlsCoverUrl.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + 1) % this.state.photoUrlsCoverUrl.length,
              })
            }
          />
        ) : null}
        {/* Light Box for videos */}
        {this.state.urlVideo.length > 0 && this.state.isOpenVideo == true ? (
          <Lightbox
            mainSrc={this.state.urlVideo[photoIndex]}
            nextSrc={
              this.state.urlVideo[(photoIndex + 1) % this.state.urlVideo.length]
            }
            prevSrc={
              this.state.urlVideo[
                (photoIndex + this.state.urlVideo.length - 1) %
                  this.state.urlVideo.length
              ]
            }
            onCloseRequest={() => {
              this.setState({
                isOpenCover: false,
                photoIndex: 0,
              });
            }}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + this.state.urlVideo.length - 1) %
                  this.state.urlVideo.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % this.state.urlVideo.length,
              })
            }
          />
        ) : null}
      </div>
    );
  }
}

export default withTranslation()(Post);
